module.exports = "https://web-assets.ifttt.com/packs/media/services/diy_background-e735ea71.png";